"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5790],{

/***/ 62371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ getFooterDSLabel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


var getFooterDSLabel = function(param) {
    var configs = param.configs, _prefix = param.prefix, prefix = _prefix === void 0 ? "" : _prefix, _suffix = param.suffix, suffix = _suffix === void 0 ? "" : _suffix, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _customStyles = param.customStyles, customStyles = _customStyles === void 0 ? {} : _customStyles;
    var ref;
    var showDsLabel = !!((ref = configs === null || configs === void 0 ? void 0 : configs.ds_branding_flag) !== null && ref !== void 0 ? ref : 1);
    if (showDsLabel) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                prefix ? "".concat(prefix, " powered") : "Powered",
                " by \xa0",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                    href: "https://download.digitalshowroom.app/download-cfe",
                    target: "_blank",
                    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("underline copyright-text-grey-color tw-cursor-pointer", customClasses),
                    rel: "website app link noreferrer",
                    style: customStyles,
                    children: [
                        "Digital Showroom ",
                        suffix
                    ]
                })
            ]
        });
    }
    return null;
};


/***/ }),

/***/ 5790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B9": function() { return /* binding */ getStoreLogo; },
/* harmony export */   "Ds": function() { return /* binding */ getSpecificPageVisibleItems; },
/* harmony export */   "E2": function() { return /* binding */ getFooterRightReservedtext; },
/* harmony export */   "Eb": function() { return /* binding */ getDescription; },
/* harmony export */   "IL": function() { return /* binding */ getAddressDetails; },
/* harmony export */   "dw": function() { return /* binding */ getActiveSocialMedia; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_handleRouteChangesOnClick__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79570);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13886);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(44541);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80344);
/* harmony import */ var src_components_DesignSystem_Footers_footerUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62371);






var getStoreLogo = function(storeContent, handleLogoClick) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    return (storeContent === null || storeContent === void 0 ? void 0 : (ref = storeContent.content) === null || ref === void 0 ? void 0 : (ref1 = ref.storeDetails) === null || ref1 === void 0 ? void 0 : ref1.store_logo_url) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
        className: "store_logo_image",
        src: (ref2 = storeContent.content) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.storeDetails) === null || ref3 === void 0 ? void 0 : ref3.store_logo_url,
        alt: "store_logo",
        width: (storeContent === null || storeContent === void 0 ? void 0 : (ref4 = storeContent.content) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.storeDetails) === null || ref5 === void 0 ? void 0 : ref5.store_logo_size) ? "".concat(parseInt((ref6 = storeContent.content) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.storeDetails) === null || ref7 === void 0 ? void 0 : ref7.store_logo_size), "px") : "0px",
        height: (storeContent === null || storeContent === void 0 ? void 0 : (ref8 = storeContent.content) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.storeDetails) === null || ref9 === void 0 ? void 0 : ref9.store_logo_size) ? "".concat(parseInt((ref10 = storeContent.content) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.storeDetails) === null || ref11 === void 0 ? void 0 : ref11.store_logo_size), "px") : "0px",
        onError: function(e) {
            var ref, ref1;
            return e.target.src = (ref = storeContent.content) === null || ref === void 0 ? void 0 : (ref1 = ref.storeDetails) === null || ref1 === void 0 ? void 0 : ref1.store_logo_url;
        },
        onClick: handleLogoClick,
        style: {
            cursor: "pointer"
        },
        loading: "lazy"
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "store_logo_name",
        children: _redux_store__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getState */ .Z.getState().storeReducer.store.store_name
    });
};
var getSpecificPageVisibleItems = function(footerContent) {
    var ref, ref1, ref2, ref3;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "privacy-terms-container",
        children: [
            (footerContent === null || footerContent === void 0 ? void 0 : (ref = footerContent.content) === null || ref === void 0 ? void 0 : (ref1 = ref.pageDetailsVisibility) === null || ref1 === void 0 ? void 0 : ref1.privacyPolicy) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "privacy-policies",
                onClick: function() {
                    return (0,_utils_handleRouteChangesOnClick__WEBPACK_IMPORTED_MODULE_1__/* .handleRouteChangesOnClick */ .Z)(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.STORE_POLICIES, {
                        page_type: _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .FOOTER_STORE_POLICIES_PAGE_TYPE */ .rl === null || _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .FOOTER_STORE_POLICIES_PAGE_TYPE */ .rl === void 0 ? void 0 : _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .FOOTER_STORE_POLICIES_PAGE_TYPE.POLICY */ .rl.POLICY
                    });
                },
                style: {
                    cursor: "pointer"
                },
                children: "Privacy Policy"
            }),
            (footerContent === null || footerContent === void 0 ? void 0 : (ref2 = footerContent.content) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.pageDetailsVisibility) === null || ref3 === void 0 ? void 0 : ref3.termsAndConditions) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "terms-conditions",
                onClick: function() {
                    return (0,_utils_handleRouteChangesOnClick__WEBPACK_IMPORTED_MODULE_1__/* .handleRouteChangesOnClick */ .Z)(_utils_routes__WEBPACK_IMPORTED_MODULE_3__.PATH.STORE_POLICIES, {
                        page_type: _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .FOOTER_STORE_POLICIES_PAGE_TYPE */ .rl === null || _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .FOOTER_STORE_POLICIES_PAGE_TYPE */ .rl === void 0 ? void 0 : _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .FOOTER_STORE_POLICIES_PAGE_TYPE.TNC */ .rl.TNC
                    });
                },
                style: {
                    cursor: "pointer"
                },
                children: "Terms & Conditions"
            })
        ]
    });
};
var getAddressDetails = function(footerContent) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "addressContainer",
        children: ((footerContent === null || footerContent === void 0 ? void 0 : (ref = footerContent.content) === null || ref === void 0 ? void 0 : (ref1 = ref.storeDetails) === null || ref1 === void 0 ? void 0 : ref1.address) || (footerContent === null || footerContent === void 0 ? void 0 : (ref2 = footerContent.content) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.storeDetails) === null || ref3 === void 0 ? void 0 : ref3.phone) || (footerContent === null || footerContent === void 0 ? void 0 : (ref4 = footerContent.content) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.storeDetails) === null || ref5 === void 0 ? void 0 : ref5.email)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "address",
            children: [
                footerContent === null || footerContent === void 0 ? void 0 : (ref6 = footerContent.content) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.storeDetails) === null || ref7 === void 0 ? void 0 : ref7.address,
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "contact",
                    children: [
                        (footerContent === null || footerContent === void 0 ? void 0 : (ref8 = footerContent.content) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.storeDetails) === null || ref9 === void 0 ? void 0 : ref9.phone) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                "Phone ",
                                footerContent === null || footerContent === void 0 ? void 0 : (ref10 = footerContent.content) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.storeDetails) === null || ref11 === void 0 ? void 0 : ref11.phone
                            ]
                        }),
                        " ",
                        (footerContent === null || footerContent === void 0 ? void 0 : (ref12 = footerContent.content) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.storeDetails) === null || ref13 === void 0 ? void 0 : ref13.email) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: "\xa0| \xa0"
                        }),
                        " ",
                        (footerContent === null || footerContent === void 0 ? void 0 : (ref14 = footerContent.content) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.storeDetails) === null || ref15 === void 0 ? void 0 : ref15.email) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: [
                                "Email ",
                                footerContent === null || footerContent === void 0 ? void 0 : (ref16 = footerContent.content) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.storeDetails) === null || ref17 === void 0 ? void 0 : ref17.email
                            ]
                        }),
                        " "
                    ]
                })
            ]
        })
    });
};
var getActiveSocialMedia = function(store) {
    var ref, ref1;
    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "social-media-section",
        style: {
            gap: "16px"
        },
        children: store === null || store === void 0 ? void 0 : (ref = store.social_media_profile_details) === null || ref === void 0 ? void 0 : (ref1 = ref.media_detail) === null || ref1 === void 0 ? void 0 : ref1.map(function(profile) {
            return profile.profile_url !== "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "social-media-icon",
                style: {
                    height: "24px",
                    width: "24px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: profile.profile_url,
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: profile.image_url,
                        alt: "".concat(profile === null || profile === void 0 ? void 0 : profile.name, " image")
                    })
                })
            }, profile.id) : null;
        })
    });
};
var getFooterRightReservedtext = function() {
    var ref, ref1, ref2, ref3;
    var currentYear = new Date().getFullYear();
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_4__/* ["default"].getState */ .Z.getState().storeReducer.store;
    var footerConfig = storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Footer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.config;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "footer-rights-container",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "copyright",
                children: [
                    "\xa9 ",
                    storeData.store_name || "Brand Name",
                    ". All Rights Reserved ",
                    currentYear
                ]
            }),
            !(footerConfig === null || footerConfig === void 0 ? void 0 : footerConfig.hide_ds_label) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "copyright-sub-text",
                children: (0,src_components_DesignSystem_Footers_footerUtils__WEBPACK_IMPORTED_MODULE_5__/* .getFooterDSLabel */ .m)({
                    configs: storeData === null || storeData === void 0 ? void 0 : storeData.configs,
                    prefix: "Website",
                    customClasses: "!tw-no-underline !tw-text-inherit !tw-opacity-100"
                })
            })
        ]
    });
};
var getDescription = function(footerContent) {
    var ref, ref1;
    return (footerContent === null || footerContent === void 0 ? void 0 : (ref = footerContent.description) === null || ref === void 0 ? void 0 : ref.text) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "footer-description",
        children: footerContent === null || footerContent === void 0 ? void 0 : (ref1 = footerContent.description) === null || ref1 === void 0 ? void 0 : ref1.text
    });
};


/***/ }),

/***/ 79570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ handleRouteChangesOnClick; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80344);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44541);



var handleRouteChangesOnClick = function(routePath) {
    var additionalQuery = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var ref;
    var storeData = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().storeReducer.store;
    next_router__WEBPACK_IMPORTED_MODULE_1___default().push({
        pathname: (0,_routes__WEBPACK_IMPORTED_MODULE_2__.getRoute)(routePath, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain),
        query: additionalQuery
    });
};


/***/ })

}]);